import { useTranslation } from "@shared/utils/internationalization";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import GooglePlayStoreLink from "@ui-application/navigation/GooglePlayStoreLink/GooglePlayStoreLink.web";
import AppleAppStoreLink from "@ui-application/navigation/AppleAppStoreLink/AppleAppStoreLink.web";
import WebviewComponentAdaptor from "@shared/components/application/other/WebviewComponentAdaptor/WebviewComponentAdaptor.web";
import type { DownloadAppSharedProps } from "./DownloadApp.props";

export default function DownloadApp(): JSX.Element | null {
  const { t } = useTranslation("checkout");

  return (
    <WebviewComponentAdaptor
      webComponent={
        <Flex direction="column" gap="md" data-testid="download-app">
          <Text fontSize="lg" lineHeight="21px" fontWeight={700}>
            {t("Download the Showpass app")}
          </Text>
          <Flex gap="xs">
            <AppleAppStoreLink />
            <GooglePlayStoreLink />
          </Flex>
        </Flex>
      }
      webviewComponent={null}
    />
  );
}

export type DownloadAppProps = DownloadAppSharedProps & {
  // Add any web specific props here.
};
